import { useState, useEffect } from 'react';

// 判断窗口宽度是否小于多少px
function useScreenWidthBelowThreshold(threshold) {
  const [isScreenWidthBelowThreshold, setIsScreenWidthBelowThreshold] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const handleResize = () => {
      setIsScreenWidthBelowThreshold(window.innerWidth < threshold);
    };
    handleResize(); // Call the function initially to set the correct value
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [threshold]);

  return isScreenWidthBelowThreshold;
}

export default useScreenWidthBelowThreshold;
